export enum SystemSettingSymbol {
  DISCOUNTS_AND_PROMOTIONS_RECALCULATION = 'Central.Sales.DiscountsAndPromotionsRecalculation',
}
